export async function useFetchTariffs(
  client: string,
  locale: string,
  actioncode: string
) {
  const { data, error } = await useFetch<Tariff[]>('/tariffs', {
    method: 'get',
    server: true,
    query: {
      client,
      language: locale,
      actioncode,
    },
    baseURL: useRuntimeConfig().public.apiBaseURL,
    transform: (response: any) => {
      return response.data
    },
  })
  return { data, error }
}
